/* tslint:disable */
/* eslint-disable */


/*
    selectedOptions {
      rewards {
        type
      }
      perks {
        type
      }
    }
*/

export const updatePartner = /* GraphQL */ `
  mutation UpdatePartner(
    $partnerUpdate: PartnerUpdate!
    $username: String!
    $signUp: Boolean
  ) {
    updatePartner(
      partnerUpdate: $partnerUpdate
      username: $username
      signUp: $signUp
    ) {

      emailAddress
      firstName
      lastName
      brandIds
      didLogin
      description
      organization
      phoneNumber
      website
      images {
        logoUrl
      }
      address {
        street
        city
        province
        country
        postalCode
      }
      premiumSettings {
        users {
          firstName
          lastName
          emailAddress
          userId
        }
        percentage
        availableSeats
      }
    }
  }
`;

export const addPartnerAddress = /* GraphQL */ `
  mutation AddPartnerAddress($street: String!, $city: String!, $province: String!, $country: String!, $postalCode: String!) {
    addPartnerAddress(street: $street, city: $city, province: $province, country: $country, postalCode: $postalCode) {
      emailAddress
      firstName
      lastName
      brandIds
      didLogin
      description
      organization
      phoneNumber
      website
      address {
        street
        city
        province
        country
        postalCode
      }
      premiumSettings {
        users {
          firstName
          lastName
          emailAddress
          userId
        }
        percentage
        availableSeats
      }
    }
  }
`;

export const addUserToPremiumPartner = /* GraphQL */ `
  mutation AddUserToPremiumPartner($firstName: String!, $lastName: String!, $userEmail: String!, $paymentId: String!, $employmentStartDate: String, $birthday: String, $autoSignUp: Boolean, $language: String) {
    addUserToPremiumPartner(firstName: $firstName, lastName: $lastName, userEmail: $userEmail, paymentId: $paymentId, employmentStartDate: $employmentStartDate, birthday: $birthday, autoSignUp: $autoSignUp, language: $language) {
      emailAddress
      firstName
      lastName
      brandIds
      didLogin
      description
      organization
      phoneNumber
      website
      address {
        street
        city
        province
        country
        postalCode
      }
      premiumSettings {
        users {
          firstName
          lastName
          emailAddress
          userId
          employmentStartDate
          birthday
        }
        percentage
        availableSeats
      }
    }
  }
`;

export const editUserFromPremiumPartner = /* GraphQL */ `
  mutation EditUserFromPremiumPartner($firstName: String!, $lastName: String!, $index: Int!, $employmentStartDate: String, $birthday: String) {
    editUserFromPremiumPartner(firstName: $firstName, lastName: $lastName, index: $index, employmentStartDate: $employmentStartDate, birthday: $birthday) {
      emailAddress
      firstName
      lastName
      brandIds
      didLogin
      description
      organization
      phoneNumber
      website
      address {
        street
        city
        province
        country
        postalCode
      }
      premiumSettings {
        users {
          firstName
          lastName
          emailAddress
          userId
          employmentStartDate
          birthday
        }
        percentage
        availableSeats
      }
    }
  }
`;

export const removeUserFromPremiumPartner = /* GraphQL */ `
  mutation RemoveUserFromPremiumPartner($userEmail: String!) {
    removeUserFromPremiumPartner(userEmail: $userEmail) {
      emailAddress
      firstName
      lastName
      brandIds
      didLogin
      description
      organization
      phoneNumber
      website
      address {
        street
        city
        province
        country
        postalCode
      }
      premiumSettings {
        users {
          firstName
          lastName
          emailAddress
          userId
        }
        percentage
        availableSeats
      }
    }
  }
`;

export const resendEmailToUserFromPremiumPartner = /* GraphQL */ `
mutation ResendEmailToUserFromPremiumPartner($userResendIndex: Int!) {
  resendEmailToUserFromPremiumPartner(userResendIndex: $userResendIndex) {
    emailAddress
      firstName
      lastName
      brandIds
      didLogin
      description
      organization
      phoneNumber
      website
      address {
        street
        city
        province
        country
        postalCode
      }
      premiumSettings {
        users {
          firstName
          lastName
          emailAddress
          userId
        }
        percentage
        availableSeats
      }
  }
}`;

export const saveImageToS3 = /* GraphQL */ `
  mutation SaveImageToS3($filename: String!, $bucket: String!, $data: Buffer!) {
    saveImageToS3(filename: $filename, bucket: $bucket, data: $data)
  }
`;

export const airdropGiftCard = /* GraphQL */ `
mutation AirdropGiftCard($airdropGiftCardRequest: PremiumGiftCardAirdropRequest!, $paymentId: String!) {
  airdropGiftCard(airdropGiftCardRequest: $airdropGiftCardRequest, paymentId: $paymentId) {
    emailAddress
  }
}`

export const updatePartnerBoostedRewards = /* GraphQL */ `
mutation UpdatePartnerBoostedRewards($boostedRewardsData: OfferBoostInput) {
  updatePartnerBoostedRewards(boostedRewardsData: $boostedRewardsData) {
    emailAddress
      firstName
      lastName
      brandIds
      didLogin
      description
      organization
      phoneNumber
      website
      status
      address {
        street
        city
        province
        country
        postalCode
      }
      premiumSettings {
        users {
          firstName
          lastName
          emailAddress
          userId
          employmentStartDate
          birthday
        }
        percentage
        availableSeats
      }
    offerAmountsManagement {
      offerBoost {
        isBoostingAllOffers
        boostAmount
        boostLimitPerUser
      }
    }
  }
}`;


export const createLifestyleGroup = /* GraphQL */ `
mutation CreateLifestyleGroup($group: LSAGroupInput!, $categories: [LSACategoryInput]) {
  createLifestyleGroup(group: $group, categories: $categories) {
    id
    emailAddress
    firstName
    lastName
    brandIds
    didLogin
    description
    organization
    phoneNumber
    website
    status
    images {
      logoUrl
    }
    address {
      street
      city
      province
      country
      postalCode
    }
    premiumSettings {
      users {
        firstName
        lastName
        emailAddress
        userId
        employmentStartDate
        birthday
      }
      percentage
      availableSeats
    }
    offerAmountsManagement {
      offerBoost {
        isBoostingAllOffers
        boostAmount
        boostLimitPerUser
      }
    }
    lsaGroups {
      groupId
      groupName
    }
  }
}`;

export const modifyLifestyleGroup = /* GraphQL */ `
mutation ModifyLifestyleGroup($groupId: String!, $groupUpdate: LSAGroupInput!) {
  modifyLifestyleGroup(groupId: $groupId, groupUpdate: $groupUpdate) {
    id
    name
    partnerId
    categories {
      id
      name
      description
      examples
      icon
      createdAt
      updatedAt
    }
    yearlySpendingLimit
    currency
    prorated
    startDate
    resetDate
    runOffPeriod
    status
    membersCount
    coveragePercentage
    createdAt
    updatedAt
  }
}`;

export const deleteLifestyleGroup = /* GraphQL */ `
mutation DeleteLifestyleGroup($groupId: String!) {
  deleteLifestyleGroup(groupId: $groupId) {
    id
    emailAddress
    firstName
    lastName
    brandIds
    didLogin
    description
    organization
    phoneNumber
    website
    status
    images {
      logoUrl
    }
    address {
      street
      city
      province
      country
      postalCode
    }
    premiumSettings {
      users {
        firstName
        lastName
        emailAddress
        userId
        employmentStartDate
        birthday
      }
      percentage
      availableSeats
    }
    offerAmountsManagement {
      offerBoost {
        isBoostingAllOffers
        boostAmount
        boostLimitPerUser
      }
    }
    lsaGroups {
      groupId
      groupName
    }
  }
}`;

export const approveLifestyleTransaction = /* GraphQL */ `
mutation ApproveLifestyleTransaction($transactionId: String!, $paymentId: String!) {
  approveLifestyleTransaction(transactionId: $transactionId, paymentId: $paymentId) {
    id
    status
  }
}`;

export const rejectLifestyleTransaction = /* GraphQL */ `
mutation RejectLifestyleTransaction($transactionId: String!) {
  rejectLifestyleTransaction(transactionId: $transactionId) {
    id
    status
  }
}`;
